import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage } from 'react-intl';
import { fromJS } from 'immutable';
import validator from 'validator';
import { uniqueId } from 'lodash';
import ReactResizeDetector from 'react-resize-detector';
import * as _ from 'lodash';
import moment from 'moment';
import injectReducer from 'utils/injectReducer';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import { makeSelectTripDelayStep, makeSelectTripDelayStepErrors } from './selectors';
import reducer from './reducer';
import messages from './messages';

import { Button } from '../components/Button';
import PageSectionHeader from '../components/PageSectionHeader';
import FlexBox from '../../../components/FlexBox';
import {
  ValidateGroup,
  Validate,
  ErrorMessage,
} from '../../../components/Validation';
import {
  handleFormDataChange,
  nextSlide,
  resetFormData,
  resetFormTravelInterruption,
  resetFormTravelDelay,
} from './actions';
import {
  emailMedicalTravelDocument,
} from '../../FastCover/actions';
import DatePicker from '../components/DatePicker/index';
import Textbox from '../components/Textbox';
import TextArea from '../components/TextArea';
import OptionsContainer from '../components/OptionsContainer';
import { CLAIMING_FOR } from './constants';
import { DelayInformationList } from './components/DelayInformation';
import { saveFormData } from '../actions';
import { makeSelectCurrentStep } from '../../Wizard/selectors';
import AsyncButton from '../../../components/AsyncButton/index';
import { makeSelectProgressBarStatus } from '../../ProgressBar/selectors';
import TimePickerInput from '../../../components/TimePickerInput';
import { stepTripDelayLookup } from '../../FastCover/dataMapper/claimCodeMapper';
import { required, checkDateOnly } from '../../../utils/validation/validator';
import { InsuredList } from '../Trawick.NationWide.TripCancellationStep/components/AddInsured';

export class TripDelayStep extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validationCounter: 0,
      errors: [],
      physicianEmail: false,
    };
    this.validatorGroup = new ValidateGroup();
    this.handleNext = this.handleNext.bind(this);
    this.checkFormError = this.checkFormError.bind(this);
    this.onResize = this.onResize.bind(this);

    this.saveButtonId = uniqueId();
    this.emailMeDocumentButton = _.uniqueId();
    this.clickedItemId = '';
    this.nextButton = null;
  }

  componentWillReceiveProps(nextProps) {
    const { currentStep, step, stepName } = this.props;
    if ((stepName && nextProps.validateStep === stepName) || (currentStep !== nextProps.currentStep && currentStep === step)) {
      this.checkFormError();
    }

    if (this.props.isReadOnly && nextProps.errors !== this.props.errors) {
      this.state.validationCounter += 1;
      this.validatorGroup.checkValidation();
    }

    if (!nextProps.loading) {
      this.clickedItemId = '';
    }
  }

  onChange = (propertyName) => (event) => {
    if (event === null) {
      this.props.onFormDataChange(propertyName, null);
      return;
    }

    if (event.constructor.name === 'Moment') {
      this.props.onFormDataChange(propertyName, removeTimeZoneFromDate(event.toDate().toString()));
    } else {
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      if (target.type === 'radio') {
        this.props.adjust();
      }
      this.props.onFormDataChange(propertyName, value);
    }
    // this.props.makeDirty(6);
  };

  onDelayInformationItemsChange = (data) => {
    this.props.onFormDataChange('form.delayInformationItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };
  onDelayInformationItemsChangeV2 = (data) => {
    this.props.onFormDataChange('form.delayInformationItemsTripDelayPerDay', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };
  onDelayInformationItemsChangeV3 = (data) => {
    this.props.onFormDataChange('form.delayInformationItemsKennelFeesAtHome', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };
  onDelayInformationItemsChangeV4 = (data) => {
    this.props.onFormDataChange('form.delayInformationItemsKennelFeesOnTrip', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onResize = () => {
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  };

  onInsuredTripDelayChange = (data) => {
    this.props.onFormDataChange('form.insuredsTripDelay', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };
  onInsuredTripDelayPerDayChange = (data) => {
    this.props.onFormDataChange('form.insuredsTripDelayPerDay', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };
  onInsuredKennelFeesAtHomeChange = (data) => {
    this.props.onFormDataChange('form.insuredsKennelFeesAtHome', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };
  onInsuredKennelFeesOnTripChange = (data) => {
    this.props.onFormDataChange('form.insuredsKennelFeesOnTrip', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  getSelectedClaiming = () => {
    const {
      claimForPassportCreditCard,
      claimForTheftOfCash,
      claimForLuggageAndPersonalEffect,
    } = this.props.form;

    let selectedValue = null;

    switch ('true') {
      case claimForPassportCreditCard:
        selectedValue = CLAIMING_FOR.PASSPORT_CREDIT_CARD;
        break;
      case claimForTheftOfCash:
        selectedValue = CLAIMING_FOR.THEFT_OF_CASH;
        break;
      case claimForLuggageAndPersonalEffect:
        selectedValue = CLAIMING_FOR.LUGGAGE_AND_PERSONAL_EFFECTS;
        break;
      default:
        selectedValue = null;
        break;
    }

    return selectedValue;
  };

  shouldDisable = (field) => {
    const selectedValue = this.getSelectedClaiming();

    return !!selectedValue && selectedValue !== field;
  };

  appendIds = (array) =>
    array.map((item) => {
      let newItem = item; // eslint-disable-line
      if (!item.id) {
        newItem.id = new Date().getTime().toString();
      }
      return newItem;
    });

  validateTableField(groups) {
    const invalid = _.some(groups, (fields) =>
      _.some(fields, (value) => {
        const newValue = value ? value.toString() : '';
        return validator.isEmpty(newValue);
      })
    );
    return invalid;
  }

  handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'Tab') {
      return;
    }
    if (e.key === 'Tab') {
      e.preventDefault();
    }
  };

  handleSaveButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.onFormDataSave();
    this.nextButton.focus();
  };

  showSpinnerForElement = (elementId) => this.clickedItemId === elementId;

  checkFormError() {
    const {
      travelDelay,
    } = this.props.form;
    const isSelectBenefit = travelDelay === 'true';
    const valid = isSelectBenefit && this.validatorGroup.checkValidation();
    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }
  }

  handleChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.props.onFormDataChange(propertyName, value);
  };

  handleNext = () => {
    const {
      travelDelay,
    } = this.props.form;
    const isSelectBenefit = travelDelay === 'true';
    const { submitted } = this.props;
    if (submitted) {
      this.props.next();
      return;
    }

    // const errors = this.validatorGroup.getErrors();
    const valid = isSelectBenefit && this.validatorGroup.checkValidation();

    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }

    this.props.onFormDataSave();
    this.props.next();
  };

  handleFormDataSave = () => {
    this.props.onFormDataSave();
  };

  handleDayChange = (propertyName) => (day) => {
    const dayWithoutTimeZone = removeTimeZoneFromDate(day);
    this.props.onFormDataChange(propertyName, dayWithoutTimeZone);
    // this.props.makeDirty(6);
  };

  handleReasonsForTripInterruption = (propertyName) => (event) => {
    const { reasonsForTripInterruption } = this.props.form;
    const reasons = !!reasonsForTripInterruption && typeof reasonsForTripInterruption.toJS === 'function'
      ? reasonsForTripInterruption.toJS()
      : reasonsForTripInterruption || [];
    const listChecked = _.cloneDeep(reasons);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  handleReasonsForTripCancellation = (propertyName) => (event) => {
    const { reasonsForTripCancellation } = this.props.form;
    const reasons = !!reasonsForTripCancellation && typeof reasonsForTripCancellation.toJS === 'function'
      ? reasonsForTripCancellation.toJS()
      : reasonsForTripCancellation || [];
    const listChecked = _.cloneDeep(reasons);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  handleChangePhoneNumber = (propertyName) => (event) => {
    const target = event.target;
    const regex = /^[0-9-]+$/;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (regex.test(value) || value === '') {
      this.props.onFormDataChange(propertyName, value);
    }
  };

  handleReasonsForDelay = (propertyName) => (event) => {
    const { reasonsForDelay } = this.props.form;
    const reasons = !!reasonsForDelay && typeof reasonsForDelay.toJS === 'function'
      ? reasonsForDelay.toJS()
      : reasonsForDelay || [];
    const listChecked = _.cloneDeep(reasons);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  summaryFormValue() {
    return _.mapValues(this.props.form, (prop) => prop || 'N/A');
  }

  handleUncheckedFormState = (field, resetAction) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    if (value === 'false') {
      resetAction();
    }

    this.handleChange(field)(event);
  };

  handleEmailMeButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.sendPhysicianEmail();
  };

  renderDelayInformationItems() {
    const { delayInformationItems } = this.props.form;
    const newDelayInformationItems = this.appendIds(delayInformationItems);
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <DelayInformationList
          data={newDelayInformationItems}
          onChange={this.onDelayInformationItemsChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
        />
      </div>
    );
  }

  renderTripDelayPerDayInformationItems() {
    const { delayInformationItemsTripDelayPerDay } = this.props.form;
    const newDelayInformationItems = this.appendIds(delayInformationItemsTripDelayPerDay);
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <DelayInformationList
          data={newDelayInformationItems}
          onChange={this.onDelayInformationItemsChangeV2}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
        />
      </div>
    );
  }

  renderKennelFeesAtHomeInformationItems() {
    const { delayInformationItemsKennelFeesAtHome } = this.props.form;
    const newDelayInformationItems = this.appendIds(delayInformationItemsKennelFeesAtHome);
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <DelayInformationList
          data={newDelayInformationItems}
          onChange={this.onDelayInformationItemsChangeV3}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
        />
      </div>
    );
  }

  renderKennelFeesOnTripInformationItems() {
    const { delayInformationItemsKennelFeesOnTrip } = this.props.form;
    const newDelayInformationItems = this.appendIds(delayInformationItemsKennelFeesOnTrip);
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <DelayInformationList
          data={newDelayInformationItems}
          onChange={this.onDelayInformationItemsChangeV4}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
        />
      </div>
    );
  }

  renderInsuredTripDelayItems() {
    const { insuredsTripDelay } = this.props.form;
    const newDelayInformationItems = this.appendIds(insuredsTripDelay);
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <InsuredList
          data={newDelayInformationItems}
          onChange={this.onInsuredTripDelayChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
        />
      </div>
    );
  }

  renderInsuredTripDelayPerDayItems() {
    const { insuredsTripDelayPerDay } = this.props.form;
    const newDelayInformationItems = this.appendIds(insuredsTripDelayPerDay);
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <InsuredList
          data={newDelayInformationItems}
          onChange={this.onInsuredTripDelayPerDayChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
        />
      </div>
    );
  }

  renderInsuredKennelFeesAtHomeItems() {
    const { insuredsKennelFeesAtHome } = this.props.form;
    const newDelayInformationItems = this.appendIds(insuredsKennelFeesAtHome);
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <InsuredList
          data={newDelayInformationItems}
          onChange={this.onInsuredKennelFeesAtHomeChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
        />
      </div>
    );
  }

  renderInsuredKennelFeesOnTripItems() {
    const { insuredsKennelFeesOnTrip } = this.props.form;
    const newDelayInformationItems = this.appendIds(insuredsKennelFeesOnTrip);
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <InsuredList
          data={newDelayInformationItems}
          onChange={this.onInsuredKennelFeesOnTripChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
        />
      </div>
    );
  }

  renderTravelDelay() {
    const {
      travelDelay,
      areYouClaimingForTripDelayPerDay,
      areYouClaimingForKennelFeesAtHome,
      areYouClaimingForKennelFeesOnTrip,
      schoolNameForDelay,
      companyNameTravelDelay,
      addressTravelDelay,
      cityTravelDelay,
      stateTravelDelay,
      zipCodeTravelDelay,
      contactTravelDelay,
      phoneNumberTravelDelay,
      dateOfInitialPaymentDeposit,
      includedInPackageForDelay,
      dateYouWereDueToDepart,
      timeYouWereDueToDepart,
      dateTripWasDelayed,
      dateDelayEnded,
      dateYouActuallyDeparted,
      timeYouActuallyDeparted,
      detailsRegardingYourTripDelay,
      dateTripWasDelayedWithTravelSupplier,
      dateDelayEndedForDelay,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const newTimeYouWereDueToDepart = timeYouWereDueToDepart ? moment(timeYouWereDueToDepart) : null;
    const newTimeYouActuallyDeparted = timeYouActuallyDeparted ? moment(timeYouActuallyDeparted) : null;
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;
    return (
      travelDelay === 'true' && (
        <div>
          <div className={'ml-3 row'}>
            <div className={'col-sm-6 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.areYouClaimingForTripDelayPerDay} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={areYouClaimingForTripDelayPerDay === 'true'}
                    onChange={this.handleChange('form.areYouClaimingForTripDelayPerDay')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={areYouClaimingForTripDelayPerDay === 'false'}
                    onChange={this.handleChange('form.areYouClaimingForTripDelayPerDay')}
                    // onClick={this.props.onResetFormTravelDelay}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>
          <div className={'ml-3 row'}>
            <div className={'col-sm-6 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.areYouClaimingForKennelFeesAtHome} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={areYouClaimingForKennelFeesAtHome === 'true'}
                    onChange={this.handleChange('form.areYouClaimingForKennelFeesAtHome')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={areYouClaimingForKennelFeesAtHome === 'false'}
                    onChange={this.handleChange('form.areYouClaimingForKennelFeesAtHome')}
                    // onClick={this.props.onResetFormTravelDelay}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>
          <div className={'ml-3 row'}>
            <div className={'col-sm-6 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.areYouClaimingForKennelFeesOnTrip} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={areYouClaimingForKennelFeesOnTrip === 'true'}
                    onChange={this.handleChange('form.areYouClaimingForKennelFeesOnTrip')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={areYouClaimingForKennelFeesOnTrip === 'false'}
                    onChange={this.handleChange('form.areYouClaimingForKennelFeesOnTrip')}
                    // onClick={this.props.onResetFormTravelDelay}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>
          <div className={'ml-3'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.insureds} />
            </PageSectionHeader>
            {this.renderInsuredTripDelayItems()}
          </div>
          <div className={'ml-5'}>
            <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.schoolName} />
                </PageSectionHeader>
                    <Textbox
                      name="schoolNameForDelay"
                      type="text"
                      onChange={this.handleChange('form.schoolNameForDelay')}
                      value={schoolNameForDelay}
                      disabled={isReadOnly}
                    />
              </div>
            </div>
            <div className={'row'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.travelSupplier} />
              </PageSectionHeader>
            </div>
            <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="companyNameTravelDelay"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={companyNameTravelDelay}
                  fieldName={messages.companyNameTravelInterruption}                  
                  >
                    <Textbox
                      name="companyNameTravelDelay"
                      type="text"
                      onChange={this.handleChange('form.companyNameTravelDelay')}
                      value={companyNameTravelDelay}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.companyNameTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-6 form-group'}></div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <Validate
                  name="addressTravelDelay"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={addressTravelDelay}
                  fieldName={messages.addressTravelInterruption}                  
                  >
                    <Textbox
                      name="addressTravelDelay"
                      type="text"
                      onChange={this.handleChange('form.addressTravelDelay')}
                      value={addressTravelDelay}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.addressTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="cityTravelDelay"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={cityTravelDelay}
                  fieldName={messages.cityTravelInterruption}                  
                  >
                    <Textbox
                      name="cityTravelDelay"
                      type="text"
                      onChange={this.handleChange('form.cityTravelDelay')}
                      value={cityTravelDelay}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.cityTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="stateTravelDelay"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={stateTravelDelay}
                  fieldName={messages.stateTravelInterruption}                  
                  >
                    <Textbox
                      name="stateTravelDelay"
                      type="text"
                      onChange={this.handleChange('form.stateTravelDelay')}
                      value={stateTravelDelay}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.stateTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="zipCodeTravelDelay"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={zipCodeTravelDelay}
                  fieldName={messages.zipCodeTravelInterruption}                  
                  >
                    <Textbox
                      name="zipCodeTravelDelay"
                      type="text"
                      onChange={this.handleChange('form.zipCodeTravelDelay')}
                      value={zipCodeTravelDelay}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.zipCodeTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="contactTravelDelay"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={contactTravelDelay}
                  fieldName={messages.contactTravelInterruption}                  
                  >
                    <Textbox
                      name="contactTravelDelay"
                      type="text"
                      onChange={this.handleChange('form.contactTravelDelay')}
                      value={contactTravelDelay}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.contactTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="phoneNumberTravelDelay"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={phoneNumberTravelDelay}
                  fieldName={messages.phoneNumber}                  
                  >
                    <Textbox
                      name="phoneNumberTravelDelay"
                      type="text"
                      onChange={this.handleChangePhoneNumber('form.phoneNumberTravelDelay')}
                      value={phoneNumberTravelDelay}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.phoneNumber}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-4 form-group'}></div>
            </div>
          </div>
          <div className={'ml-3'}>
            <div className={'row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="dateOfInitialPaymentDeposit"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateOfInitialPaymentDeposit}
                  fieldName={messages.dateOfInitialPaymentDeposit}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateOfInitialPaymentDeposit"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateOfInitialPaymentDeposit')}
                    value={dateOfInitialPaymentDeposit}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateOfInitialPaymentDeposit}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateOfInitialPaymentDeposit}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-8 form-group'}>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.includedInPackage} />
                </PageSectionHeader>
                <Textbox
                  name="includedInPackageForDelay"
                  type="text"
                  onChange={this.handleChange('form.includedInPackageForDelay')}
                  value={includedInPackageForDelay}
                  disabled={isReadOnly}
                />
              </div>
            </div>
            <div className="row">
              <div className="form-group col-md-6 col-sm-6">
                <Validate
                  name="dateYouWereDueToDepart"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateYouWereDueToDepart}
                  fieldName={messages.dateYouWereDueToDepart}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateYouWereDueToDepart"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateYouWereDueToDepart')}
                    value={dateYouWereDueToDepart}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateYouWereDueToDepart}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateYouWereDueToDepart}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className="form-group col-md-4 col-sm-4">
                <Validate
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  name="timeYouWereDueToDepart"
                  group={this.validatorGroup}
                  validators={[required]}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  defaultValue={newTimeYouWereDueToDepart}
                  fieldName={messages.timeYouWereDueToDepart}
                >
                  <TimePickerInput
                    allowEmpty
                    showSecond={false}
                    onChange={this.onChange('form.timeYouWereDueToDepart')}
                    value={newTimeYouWereDueToDepart}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.timeYouWereDueToDepart}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-md-2 col-sm-2 form-group'}>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="dateTripWasDelayed"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateTripWasDelayed}
                  fieldName={messages.dateTripWasDelayed}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateTripWasDelayed"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateTripWasDelayed')}
                    value={dateTripWasDelayed}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateTripWasDelayed}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateTripWasDelayed}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="dateDelayEnded"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateDelayEnded}
                  fieldName={messages.dateDelayEnded}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateDelayEnded"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateDelayEnded')}
                    value={dateDelayEnded}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateDelayEnded}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateDelayEnded}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-2 form-group'}>
              </div>
            </div>
            <div className="row">
              <div className="form-group col-md-6 col-sm-6">
                <Validate
                  name="dateYouActuallyDeparted"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateYouActuallyDeparted}
                  fieldName={messages.dateYouActuallyDeparted}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateYouActuallyDeparted"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateYouActuallyDeparted')}
                    value={dateYouActuallyDeparted}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateYouActuallyDeparted}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateYouActuallyDeparted}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className="form-group col-md-4 col-sm-4">
                <Validate
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  name="timeYouActuallyDeparted"
                  group={this.validatorGroup}
                  validators={[required]}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  defaultValue={newTimeYouActuallyDeparted}
                  fieldName={messages.timeYouActuallyDeparted}
                >
                  <TimePickerInput
                    allowEmpty
                    showSecond={false}
                    onChange={this.onChange('form.timeYouActuallyDeparted')}
                    value={newTimeYouActuallyDeparted}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.timeYouActuallyDeparted}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-md-2 col-sm-2 form-group'}>
              </div>
            </div>
          </div>
          <div className={'ml-3'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.delayInformation} />
            </PageSectionHeader>
            {this.renderDelayInformationItems()}
          </div>
          <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="dateTripWasDelayedWithTravelSupplier"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateTripWasDelayedWithTravelSupplier}
                  fieldName={messages.dateTripWasDelayedWithTravelSupplier}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateTripWasDelayedWithTravelSupplier"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateTripWasDelayedWithTravelSupplier')}
                    value={dateTripWasDelayedWithTravelSupplier}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateTripWasDelayedWithTravelSupplier}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateTripWasDelayedWithTravelSupplier}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="dateDelayEndedForDelay"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateDelayEndedForDelay}
                  fieldName={messages.dateDelayEnded}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateDelayEndedForDelay"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateDelayEndedForDelay')}
                    value={dateDelayEndedForDelay}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateDelayEnded}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateDelayEnded}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-2 form-group'}>
              </div>
          </div>
          <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <Validate
                  name="detailsRegardingYourTripDelay"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={detailsRegardingYourTripDelay}
                  fieldName={messages.detailsRegardingYourTripDelay}                  
                  >
                    <TextArea
                      name="detailsRegardingYourTripDelay"
                      type="text"
                      onChange={this.handleChange('form.detailsRegardingYourTripDelay')}
                      value={detailsRegardingYourTripDelay}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.detailsRegardingYourTripDelay}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
          </div>
        </div>
      )
    );
  }

  renderTripDelayPerDay() {
    const {
      areYouClaimingForTripDelayPerDay,
      schoolNameTripDelayPerDay,
      companyNameTripDelayPerDay,
      addressTripDelayPerDay,
      cityTripDelayPerDay,
      stateTripDelayPerDay,
      zipCodeTripDelayPerDay,
      contactTripDelayPerDay,
      phoneNumberTripDelayPerDay,
      dateOfInitialPaymentDepositTripDelayPerDay,
      includedInPackageTripDelayPerDay,
      dateYouWereDueToDepartTripDelayPerDay,
      timeYouWereDueToDepartTripDelayPerDay,
      dateTripDelayPerDay,
      dateDelayEndedTripDelayPerDay,
      dateYouActuallyDepartedTripDelayPerDay,
      timeYouActuallyDepartedTripDelayPerDay,
      dateTripWasDelayedWithTravelSupplierTripDelayPerDay,
      dateDelayEndedTripDelayPerDayV2,
      detailsRegardingYourTripDelayPerDay,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const newTimeYouWereDueToDepart = timeYouWereDueToDepartTripDelayPerDay ? moment(timeYouWereDueToDepartTripDelayPerDay) : null;
    const newTimeYouActuallyDeparted = timeYouActuallyDepartedTripDelayPerDay ? moment(timeYouActuallyDepartedTripDelayPerDay) : null;
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;
    return (
      areYouClaimingForTripDelayPerDay === 'true' && (
        <div>
          <div className={'ml-3'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.insureds} />
            </PageSectionHeader>
            {this.renderInsuredTripDelayPerDayItems()}
          </div>
          <div className={'ml-5'}>
            <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.schoolName} />
                </PageSectionHeader>
                    <Textbox
                      name="schoolNameForDelay"
                      type="text"
                      onChange={this.handleChange('form.schoolNameTripDelayPerDay')}
                      value={schoolNameTripDelayPerDay}
                      disabled={isReadOnly}
                    />
              </div>
            </div>
            <div className={'row'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.travelSupplier} />
              </PageSectionHeader>
            </div>
            <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="companyNameTravelDelay"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={companyNameTripDelayPerDay}
                  fieldName={messages.companyNameTravelInterruption}                  
                  >
                    <Textbox
                      name="companyNameTravelDelay"
                      type="text"
                      onChange={this.handleChange('form.companyNameTripDelayPerDay')}
                      value={companyNameTripDelayPerDay}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.companyNameTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-6 form-group'}></div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <Validate
                  name="addressTravelDelay"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={addressTripDelayPerDay}
                  fieldName={messages.addressTravelInterruption}                  
                  >
                    <Textbox
                      name="addressTravelDelay"
                      type="text"
                      onChange={this.handleChange('form.addressTripDelayPerDay')}
                      value={addressTripDelayPerDay}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.addressTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="cityTravelDelay"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={cityTripDelayPerDay}
                  fieldName={messages.cityTravelInterruption}                  
                  >
                    <Textbox
                      name="cityTravelDelay"
                      type="text"
                      onChange={this.handleChange('form.cityTripDelayPerDay')}
                      value={cityTripDelayPerDay}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.cityTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="stateTravelDelay"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={stateTripDelayPerDay}
                  fieldName={messages.stateTravelInterruption}                  
                  >
                    <Textbox
                      name="stateTravelDelay"
                      type="text"
                      onChange={this.handleChange('form.stateTripDelayPerDay')}
                      value={stateTripDelayPerDay}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.stateTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="zipCodeTravelDelay"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={zipCodeTripDelayPerDay}
                  fieldName={messages.zipCodeTravelInterruption}                  
                  >
                    <Textbox
                      name="zipCodeTravelDelay"
                      type="text"
                      onChange={this.handleChange('form.zipCodeTripDelayPerDay')}
                      value={zipCodeTripDelayPerDay}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.zipCodeTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="contactTravelDelay"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={contactTripDelayPerDay}
                  fieldName={messages.contactTravelInterruption}                  
                  >
                    <Textbox
                      name="contactTravelDelay"
                      type="text"
                      onChange={this.handleChange('form.contactTripDelayPerDay')}
                      value={contactTripDelayPerDay}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.contactTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="phoneNumberTravelDelay"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={phoneNumberTripDelayPerDay}
                  fieldName={messages.phoneNumber}                  
                  >
                    <Textbox
                      name="phoneNumberTravelDelay"
                      type="text"
                      onChange={this.handleChangePhoneNumber('form.phoneNumberTripDelayPerDay')}
                      value={phoneNumberTripDelayPerDay}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.phoneNumber}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-4 form-group'}></div>
            </div>
          </div>
          <div className={'ml-3'}>
            <div className={'row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="dateOfInitialPaymentDeposit"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateOfInitialPaymentDepositTripDelayPerDay}
                  fieldName={messages.dateOfInitialPaymentDeposit}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateOfInitialPaymentDeposit"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateOfInitialPaymentDepositTripDelayPerDay')}
                    value={dateOfInitialPaymentDepositTripDelayPerDay}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateOfInitialPaymentDeposit}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateOfInitialPaymentDeposit}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-8 form-group'}>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.includedInPackage} />
                </PageSectionHeader>
                <Textbox
                  name="includedInPackageForDelay"
                  type="text"
                  onChange={this.handleChange('form.includedInPackageTripDelayPerDay')}
                  value={includedInPackageTripDelayPerDay}
                  disabled={isReadOnly}
                />
              </div>
            </div>
            <div className="row">
              <div className="form-group col-md-6 col-sm-6">
                <Validate
                  name="dateYouWereDueToDepart"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateYouWereDueToDepartTripDelayPerDay}
                  fieldName={messages.dateYouWereDueToDepart}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateYouWereDueToDepart"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateYouWereDueToDepartTripDelayPerDay')}
                    value={dateYouWereDueToDepartTripDelayPerDay}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateYouWereDueToDepart}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateYouWereDueToDepart}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className="form-group col-md-4 col-sm-4">
                <Validate
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  name="timeYouWereDueToDepart"
                  group={this.validatorGroup}
                  validators={[required]}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  defaultValue={newTimeYouWereDueToDepart}
                  fieldName={messages.timeYouWereDueToDepart}
                >
                  <TimePickerInput
                    allowEmpty
                    showSecond={false}
                    onChange={this.onChange('form.timeYouWereDueToDepartTripDelayPerDay')}
                    value={newTimeYouWereDueToDepart}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.timeYouWereDueToDepart}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-md-2 col-sm-2 form-group'}>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="dateTripWasDelayed"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateTripDelayPerDay}
                  fieldName={messages.dateTripWasDelayed}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateTripWasDelayed"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateTripDelayPerDay')}
                    value={dateTripDelayPerDay}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateTripWasDelayed}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateTripWasDelayed}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="dateDelayEnded"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateDelayEndedTripDelayPerDay}
                  fieldName={messages.dateDelayEnded}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateDelayEnded"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateDelayEndedTripDelayPerDay')}
                    value={dateDelayEndedTripDelayPerDay}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateDelayEnded}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateDelayEnded}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-2 form-group'}>
              </div>
            </div>
            <div className="row">
              <div className="form-group col-md-6 col-sm-6">
                <Validate
                  name="dateYouActuallyDeparted"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateYouActuallyDepartedTripDelayPerDay}
                  fieldName={messages.dateYouActuallyDeparted}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateYouActuallyDeparted"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateYouActuallyDepartedTripDelayPerDay')}
                    value={dateYouActuallyDepartedTripDelayPerDay}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateYouActuallyDeparted}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateYouActuallyDeparted}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className="form-group col-md-4 col-sm-4">
                <Validate
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  name="timeYouActuallyDeparted"
                  group={this.validatorGroup}
                  validators={[required]}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  defaultValue={newTimeYouActuallyDeparted}
                  fieldName={messages.timeYouActuallyDeparted}
                >
                  <TimePickerInput
                    allowEmpty
                    showSecond={false}
                    onChange={this.onChange('form.timeYouActuallyDepartedTripDelayPerDay')}
                    value={newTimeYouActuallyDeparted}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.timeYouActuallyDeparted}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-md-2 col-sm-2 form-group'}>
              </div>
            </div>
          </div>
          <div className={'ml-3'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.delayInformation} />
            </PageSectionHeader>
            {this.renderTripDelayPerDayInformationItems()}
          </div>
          <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="dateTripWasDelayedWithTravelSupplier"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateTripWasDelayedWithTravelSupplierTripDelayPerDay}
                  fieldName={messages.dateTripWasDelayedWithTravelSupplier}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateTripWasDelayedWithTravelSupplier"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateTripWasDelayedWithTravelSupplierTripDelayPerDay')}
                    value={dateTripWasDelayedWithTravelSupplierTripDelayPerDay}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateTripWasDelayedWithTravelSupplier}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateTripWasDelayedWithTravelSupplier}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="dateDelayEndedForDelay"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateDelayEndedTripDelayPerDayV2}
                  fieldName={messages.dateDelayEnded}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateDelayEndedForDelay"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateDelayEndedTripDelayPerDayV2')}
                    value={dateDelayEndedTripDelayPerDayV2}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateDelayEnded}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateDelayEnded}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-2 form-group'}>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <Validate
                  name="detailsRegardingYourTripDelayPerDay"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={detailsRegardingYourTripDelayPerDay}
                  fieldName={messages.detailsRegardingYourTripDelay}                  
                  >
                    <TextArea
                      name="detailsRegardingYourTripDelayPerDay"
                      type="text"
                      onChange={this.handleChange('form.detailsRegardingYourTripDelayPerDay')}
                      value={detailsRegardingYourTripDelayPerDay}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.detailsRegardingYourTripDelay}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
            </div>
        </div>
      )
    );
  }

  renderKennelFeesAtHome() {
    const {
      areYouClaimingForKennelFeesAtHome,
      schoolNameKennelFeesAtHome,
      companyNameKennelFeesAtHome,
      addressKennelFeesAtHome,
      cityKennelFeesAtHome,
      stateKennelFeesAtHome,
      zipCodeKennelFeesAtHome,
      contactKennelFeesAtHome,
      phoneNumberKennelFeesAtHome,
      dateOfInitialPaymentDepositKennelFeesAtHome,
      includedInPackageKennelFeesAtHome,
      dateYouWereDueToDepartKennelFeesAtHome,
      timeYouWereDueToDepartKennelFeesAtHome,
      dateKennelFeesAtHome,
      dateDelayEndedKennelFeesAtHome,
      dateYouActuallyDepartedKennelFeesAtHome,
      timeYouActuallyDepartedKennelFeesAtHome,
      dateTripWasDelayedWithTravelSupplierKennelFeesAtHome,
      dateDelayEndedKennelFeesAtHomeV2,
      detailsRegardingYourKennelFeesAtHome,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const newTimeYouWereDueToDepart = timeYouWereDueToDepartKennelFeesAtHome ? moment(timeYouWereDueToDepartKennelFeesAtHome) : null;
    const newTimeYouActuallyDeparted = timeYouActuallyDepartedKennelFeesAtHome ? moment(timeYouActuallyDepartedKennelFeesAtHome) : null;
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;
    return (
      areYouClaimingForKennelFeesAtHome === 'true' && (
        <div>
          <div className={'ml-3'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.insureds} />
            </PageSectionHeader>
            {this.renderInsuredKennelFeesAtHomeItems()}
          </div>
          <div className={'ml-5'}>
            <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.schoolName} />
                </PageSectionHeader>
                    <Textbox
                      name="schoolNameForDelay"
                      type="text"
                      onChange={this.handleChange('form.schoolNameKennelFeesAtHome')}
                      value={schoolNameKennelFeesAtHome}
                      disabled={isReadOnly}
                    />
              </div>
            </div>
            <div className={'row'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.travelSupplier} />
              </PageSectionHeader>
            </div>
            <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="companyNameTravelDelay"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={companyNameKennelFeesAtHome}
                  fieldName={messages.companyNameTravelInterruption}                  
                  >
                    <Textbox
                      name="companyNameTravelDelay"
                      type="text"
                      onChange={this.handleChange('form.companyNameKennelFeesAtHome')}
                      value={companyNameKennelFeesAtHome}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.companyNameTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-6 form-group'}></div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <Validate
                  name="addressTravelDelay"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={addressKennelFeesAtHome}
                  fieldName={messages.addressTravelInterruption}                  
                  >
                    <Textbox
                      name="addressTravelDelay"
                      type="text"
                      onChange={this.handleChange('form.addressKennelFeesAtHome')}
                      value={addressKennelFeesAtHome}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.addressTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="cityTravelDelay"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={cityKennelFeesAtHome}
                  fieldName={messages.cityTravelInterruption}                  
                  >
                    <Textbox
                      name="cityTravelDelay"
                      type="text"
                      onChange={this.handleChange('form.cityKennelFeesAtHome')}
                      value={cityKennelFeesAtHome}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.cityTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="stateTravelDelay"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={stateKennelFeesAtHome}
                  fieldName={messages.stateTravelInterruption}                  
                  >
                    <Textbox
                      name="stateTravelDelay"
                      type="text"
                      onChange={this.handleChange('form.stateKennelFeesAtHome')}
                      value={stateKennelFeesAtHome}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.stateTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="zipCodeTravelDelay"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={zipCodeKennelFeesAtHome}
                  fieldName={messages.zipCodeTravelInterruption}                  
                  >
                    <Textbox
                      name="zipCodeTravelDelay"
                      type="text"
                      onChange={this.handleChange('form.zipCodeKennelFeesAtHome')}
                      value={zipCodeKennelFeesAtHome}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.zipCodeTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="contactTravelDelay"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={contactKennelFeesAtHome}
                  fieldName={messages.contactTravelInterruption}                  
                  >
                    <Textbox
                      name="contactTravelDelay"
                      type="text"
                      onChange={this.handleChange('form.contactKennelFeesAtHome')}
                      value={contactKennelFeesAtHome}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.contactTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="phoneNumberTravelDelay"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={phoneNumberKennelFeesAtHome}
                  fieldName={messages.phoneNumberTravelInterruption}                  
                  >
                    <Textbox
                      name="phoneNumberTravelDelay"
                      type="text"
                      onChange={this.handleChangePhoneNumber('form.phoneNumberKennelFeesAtHome')}
                      value={phoneNumberKennelFeesAtHome}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.phoneNumberTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-4 form-group'}></div>
            </div>
          </div>
          <div className={'ml-3'}>
            <div className={'row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="dateOfInitialPaymentDeposit"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateOfInitialPaymentDepositKennelFeesAtHome}
                  fieldName={messages.dateOfInitialPaymentDeposit}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateOfInitialPaymentDeposit"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateOfInitialPaymentDepositKennelFeesAtHome')}
                    value={dateOfInitialPaymentDepositKennelFeesAtHome}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateOfInitialPaymentDeposit}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateOfInitialPaymentDeposit}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-8 form-group'}>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.includedInPackage} />
                </PageSectionHeader>
                <Textbox
                  name="includedInPackageForDelay"
                  type="text"
                  onChange={this.handleChange('form.includedInPackageKennelFeesAtHome')}
                  value={includedInPackageKennelFeesAtHome}
                  disabled={isReadOnly}
                />
              </div>
            </div>
            <div className="row">
              <div className="form-group col-md-6 col-sm-6">
                <Validate
                  name="dateYouWereDueToDepart"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateYouWereDueToDepartKennelFeesAtHome}
                  fieldName={messages.dateYouWereDueToDepart}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateYouWereDueToDepart"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateYouWereDueToDepartKennelFeesAtHome')}
                    value={dateYouWereDueToDepartKennelFeesAtHome}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateYouWereDueToDepart}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateYouWereDueToDepart}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className="form-group col-md-4 col-sm-4">
                <Validate
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  name="timeYouWereDueToDepart"
                  group={this.validatorGroup}
                  validators={[required]}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  defaultValue={newTimeYouWereDueToDepart}
                  fieldName={messages.timeYouWereDueToDepart}
                >
                  <TimePickerInput
                    allowEmpty
                    showSecond={false}
                    onChange={this.onChange('form.timeYouWereDueToDepartKennelFeesAtHome')}
                    value={newTimeYouWereDueToDepart}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.timeYouWereDueToDepart}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-md-2 col-sm-2 form-group'}>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="dateTripWasDelayed"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateKennelFeesAtHome}
                  fieldName={messages.dateTripWasDelayed}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateTripWasDelayed"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateKennelFeesAtHome')}
                    value={dateKennelFeesAtHome}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateTripWasDelayed}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateTripWasDelayed}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="dateDelayEnded"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateDelayEndedKennelFeesAtHome}
                  fieldName={messages.dateDelayEnded}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateDelayEnded"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateDelayEndedKennelFeesAtHome')}
                    value={dateDelayEndedKennelFeesAtHome}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateDelayEnded}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateDelayEnded}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-2 form-group'}>
              </div>
            </div>
            <div className="row">
              <div className="form-group col-md-6 col-sm-6">
                <Validate
                  name="dateYouActuallyDeparted"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateYouActuallyDepartedKennelFeesAtHome}
                  fieldName={messages.dateYouActuallyDeparted}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateYouActuallyDeparted"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateYouActuallyDepartedKennelFeesAtHome')}
                    value={dateYouActuallyDepartedKennelFeesAtHome}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateYouActuallyDeparted}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateYouActuallyDeparted}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className="form-group col-md-4 col-sm-4">
                <Validate
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  name="timeYouActuallyDeparted"
                  group={this.validatorGroup}
                  validators={[required]}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  defaultValue={newTimeYouActuallyDeparted}
                  fieldName={messages.timeYouActuallyDeparted}
                >
                  <TimePickerInput
                    allowEmpty
                    showSecond={false}
                    onChange={this.onChange('form.timeYouActuallyDepartedKennelFeesAtHome')}
                    value={newTimeYouActuallyDeparted}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.timeYouActuallyDeparted}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-md-2 col-sm-2 form-group'}>
              </div>
            </div>
          </div>
          <div className={'ml-3'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.delayInformation} />
            </PageSectionHeader>
            {this.renderKennelFeesAtHomeInformationItems()}
          </div>
          <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="dateTripWasDelayedWithTravelSupplier"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateTripWasDelayedWithTravelSupplierKennelFeesAtHome}
                  fieldName={messages.dateTripWasDelayedWithTravelSupplier}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateTripWasDelayedWithTravelSupplier"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateTripWasDelayedWithTravelSupplierKennelFeesAtHome')}
                    value={dateTripWasDelayedWithTravelSupplierKennelFeesAtHome}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateTripWasDelayedWithTravelSupplier}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateTripWasDelayedWithTravelSupplier}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="dateDelayEndedForDelay"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateDelayEndedKennelFeesAtHomeV2}
                  fieldName={messages.dateDelayEnded}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateDelayEndedForDelay"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateDelayEndedKennelFeesAtHomeV2')}
                    value={dateDelayEndedKennelFeesAtHomeV2}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateDelayEnded}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateDelayEnded}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-2 form-group'}>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <Validate
                  name="detailsRegardingYourKennelFeesAtHome"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={detailsRegardingYourKennelFeesAtHome}
                  fieldName={messages.detailsRegardingYourTripDelay}                  
                  >
                    <TextArea
                      name="detailsRegardingYourKennelFeesAtHome"
                      type="text"
                      onChange={this.handleChange('form.detailsRegardingYourKennelFeesAtHome')}
                      value={detailsRegardingYourKennelFeesAtHome}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.detailsRegardingYourTripDelay}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
            </div>
        </div>
      )
    );
  }

  renderKennelFeesOnTrip() {
    const {
      areYouClaimingForKennelFeesOnTrip,
      schoolNameKennelFeesOnTrip,
      companyNameKennelFeesOnTrip,
      addressKennelFeesOnTrip,
      cityKennelFeesOnTrip,
      stateKennelFeesOnTrip,
      zipCodeKennelFeesOnTrip,
      contactKennelFeesOnTrip,
      phoneNumberKennelFeesOnTrip,
      dateOfInitialPaymentDepositKennelFeesOnTrip,
      includedInPackageKennelFeesOnTrip,
      dateYouWereDueToDepartKennelFeesOnTrip,
      timeYouWereDueToDepartKennelFeesOnTrip,
      dateKennelFeesOnTrip,
      dateDelayEndedKennelFeesOnTrip,
      dateYouActuallyDepartedKennelFeesOnTrip,
      timeYouActuallyDepartedKennelFeesOnTrip,
      dateTripWasDelayedWithTravelSupplierKennelFeesOnTrip,
      dateDelayEndedKennelFeesOnTripV2,
      detailsRegardingYourKennelFeesOnTrip,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const newTimeYouWereDueToDepart = timeYouWereDueToDepartKennelFeesOnTrip ? moment(timeYouWereDueToDepartKennelFeesOnTrip) : null;
    const newTimeYouActuallyDeparted = timeYouActuallyDepartedKennelFeesOnTrip ? moment(timeYouActuallyDepartedKennelFeesOnTrip) : null;
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;
    return (
      areYouClaimingForKennelFeesOnTrip === 'true' && (
        <div>
          <div className={'ml-3'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.insureds} />
            </PageSectionHeader>
            {this.renderInsuredKennelFeesOnTripItems()}
          </div>
          <div className={'ml-5'}>
            <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.schoolName} />
                </PageSectionHeader>
                    <Textbox
                      name="schoolNameForDelay"
                      type="text"
                      onChange={this.handleChange('form.schoolNameKennelFeesOnTrip')}
                      value={schoolNameKennelFeesOnTrip}
                      disabled={isReadOnly}
                    />
              </div>
            </div>
            <div className={'row'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.travelSupplier} />
              </PageSectionHeader>
            </div>
            <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="companyNameTravelDelay"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={companyNameKennelFeesOnTrip}
                  fieldName={messages.companyNameTravelInterruption}                  
                  >
                    <Textbox
                      name="companyNameTravelDelay"
                      type="text"
                      onChange={this.handleChange('form.companyNameKennelFeesOnTrip')}
                      value={companyNameKennelFeesOnTrip}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.companyNameTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-6 form-group'}></div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <Validate
                  name="addressTravelDelay"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={addressKennelFeesOnTrip}
                  fieldName={messages.addressTravelInterruption}                  
                  >
                    <Textbox
                      name="addressTravelDelay"
                      type="text"
                      onChange={this.handleChange('form.addressKennelFeesOnTrip')}
                      value={addressKennelFeesOnTrip}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.addressTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="cityTravelDelay"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={cityKennelFeesOnTrip}
                  fieldName={messages.cityTravelInterruption}                  
                  >
                    <Textbox
                      name="cityTravelDelay"
                      type="text"
                      onChange={this.handleChange('form.cityKennelFeesOnTrip')}
                      value={cityKennelFeesOnTrip}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.cityTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="stateTravelDelay"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={stateKennelFeesOnTrip}
                  fieldName={messages.stateTravelInterruption}                  
                  >
                    <Textbox
                      name="stateTravelDelay"
                      type="text"
                      onChange={this.handleChange('form.stateKennelFeesOnTrip')}
                      value={stateKennelFeesOnTrip}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.stateTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="zipCodeTravelDelay"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={zipCodeKennelFeesOnTrip}
                  fieldName={messages.zipCodeTravelInterruption}                  
                  >
                    <Textbox
                      name="zipCodeTravelDelay"
                      type="text"
                      onChange={this.handleChange('form.zipCodeKennelFeesOnTrip')}
                      value={zipCodeKennelFeesOnTrip}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.zipCodeTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="contactTravelDelay"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={contactKennelFeesOnTrip}
                  fieldName={messages.contactTravelInterruption}                  
                  >
                    <Textbox
                      name="contactTravelDelay"
                      type="text"
                      onChange={this.handleChange('form.contactKennelFeesOnTrip')}
                      value={contactKennelFeesOnTrip}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.contactTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="phoneNumberTravelDelay"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={phoneNumberKennelFeesOnTrip}
                  fieldName={messages.phoneNumber}                  
                  >
                    <Textbox
                      name="phoneNumberTravelDelay"
                      type="text"
                      onChange={this.handleChangePhoneNumber('form.phoneNumberKennelFeesOnTrip')}
                      value={phoneNumberKennelFeesOnTrip}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.phoneNumber}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-4 form-group'}></div>
            </div>
          </div>
          <div className={'ml-3'}>
            <div className={'row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="dateOfInitialPaymentDeposit"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateOfInitialPaymentDepositKennelFeesOnTrip}
                  fieldName={messages.dateOfInitialPaymentDeposit}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateOfInitialPaymentDeposit"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateOfInitialPaymentDepositKennelFeesOnTrip')}
                    value={dateOfInitialPaymentDepositKennelFeesOnTrip}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateOfInitialPaymentDeposit}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateOfInitialPaymentDeposit}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-8 form-group'}>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.includedInPackage} />
                </PageSectionHeader>
                <Textbox
                  name="includedInPackageForDelay"
                  type="text"
                  onChange={this.handleChange('form.includedInPackageKennelFeesOnTrip')}
                  value={includedInPackageKennelFeesOnTrip}
                  disabled={isReadOnly}
                />
              </div>
            </div>
            <div className="row">
              <div className="form-group col-md-6 col-sm-6">
                <Validate
                  name="dateYouWereDueToDepart"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateYouWereDueToDepartKennelFeesOnTrip}
                  fieldName={messages.dateYouWereDueToDepart}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateYouWereDueToDepart"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateYouWereDueToDepartKennelFeesOnTrip')}
                    value={dateYouWereDueToDepartKennelFeesOnTrip}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateYouWereDueToDepart}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateYouWereDueToDepart}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className="form-group col-md-4 col-sm-4">
                <Validate
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  name="timeYouWereDueToDepart"
                  group={this.validatorGroup}
                  validators={[required]}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  defaultValue={newTimeYouWereDueToDepart}
                  fieldName={messages.timeYouWereDueToDepart}
                >
                  <TimePickerInput
                    allowEmpty
                    showSecond={false}
                    onChange={this.onChange('form.timeYouWereDueToDepartKennelFeesOnTrip')}
                    value={newTimeYouWereDueToDepart}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.timeYouWereDueToDepart}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-md-2 col-sm-2 form-group'}>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="dateTripWasDelayed"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateKennelFeesOnTrip}
                  fieldName={messages.dateTripWasDelayed}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateTripWasDelayed"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateKennelFeesOnTrip')}
                    value={dateKennelFeesOnTrip}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateTripWasDelayed}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateTripWasDelayed}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="dateDelayEnded"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateDelayEndedKennelFeesOnTrip}
                  fieldName={messages.dateDelayEnded}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateDelayEnded"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateDelayEndedKennelFeesOnTrip')}
                    value={dateDelayEndedKennelFeesOnTrip}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateDelayEnded}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateDelayEnded}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-2 form-group'}>
              </div>
            </div>
            <div className="row">
              <div className="form-group col-md-6 col-sm-6">
                <Validate
                  name="dateYouActuallyDeparted"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateYouActuallyDepartedKennelFeesOnTrip}
                  fieldName={messages.dateYouActuallyDeparted}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateYouActuallyDeparted"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateYouActuallyDepartedKennelFeesOnTrip')}
                    value={dateYouActuallyDepartedKennelFeesOnTrip}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateYouActuallyDeparted}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateYouActuallyDeparted}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className="form-group col-md-4 col-sm-4">
                <Validate
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  name="timeYouActuallyDeparted"
                  group={this.validatorGroup}
                  validators={[required]}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  defaultValue={newTimeYouActuallyDeparted}
                  fieldName={messages.timeYouActuallyDeparted}
                >
                  <TimePickerInput
                    allowEmpty
                    showSecond={false}
                    onChange={this.onChange('form.timeYouActuallyDepartedKennelFeesOnTrip')}
                    value={newTimeYouActuallyDeparted}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.timeYouActuallyDeparted}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-md-2 col-sm-2 form-group'}>
              </div>
            </div>
          </div>
          <div className={'ml-3'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.delayInformation} />
            </PageSectionHeader>
            {this.renderKennelFeesOnTripInformationItems()}
          </div>
          <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="dateTripWasDelayedWithTravelSupplier"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateTripWasDelayedWithTravelSupplierKennelFeesOnTrip}
                  fieldName={messages.dateTripWasDelayedWithTravelSupplier}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateTripWasDelayedWithTravelSupplier"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateTripWasDelayedWithTravelSupplierKennelFeesOnTrip')}
                    value={dateTripWasDelayedWithTravelSupplierKennelFeesOnTrip}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateTripWasDelayedWithTravelSupplier}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateTripWasDelayedWithTravelSupplier}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="dateDelayEndedForDelay"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateDelayEndedKennelFeesOnTripV2}
                  fieldName={messages.dateDelayEnded}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateDelayEndedForDelay"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateDelayEndedKennelFeesOnTripV2')}
                    value={dateDelayEndedKennelFeesOnTripV2}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateDelayEnded}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateDelayEnded}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-2 form-group'}>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <Validate
                  name="detailsRegardingYourKennelFeesOnTrip"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={detailsRegardingYourKennelFeesOnTrip}
                  fieldName={messages.detailsRegardingYourTripDelay}                  
                  >
                    <TextArea
                      name="detailsRegardingYourKennelFeesOnTrip"
                      type="text"
                      onChange={this.handleChange('form.detailsRegardingYourKennelFeesOnTrip')}
                      value={detailsRegardingYourKennelFeesOnTrip}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.detailsRegardingYourTripDelay}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
            </div>
        </div>
      )
    );
  }

  render() {
    const {
      travelDelay,
    } = isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted, loading } = this.props;
    const isRenderTravelDelay = !!stepTripDelayLookup.travelDelay.claimCode;
    const isReadOnly = submitted || isSummary;
    return (
      <div className="app-content">
        {isRenderTravelDelay &&
          <div className={'row'}>
            <div className={'col-sm-6 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.travelDelay} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={travelDelay === 'true'}
                    onChange={this.handleChange('form.travelDelay')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={travelDelay === 'false'}
                    onChange={this.handleChange('form.travelDelay')}
                    onClick={this.props.onResetFormTravelDelay}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>}
        {isRenderTravelDelay && this.renderTravelDelay()}

        {!isSummary && (
          <div className={'row justify-content-between'}>
            <div className={'col-12 col-sm-auto'}>
              <div className={'row'}>
                <div className={'col-12 col-sm-auto'}>
                  <button
                    className="btn-outline"
                    onClick={this.props.prev}
                    onKeyDown={this.handleKeyDown}
                  >
                    Back
                  </button>
                </div>
                <div className={'col-12 col-sm-auto'}>
                  <Button
                    onClick={this.handleNext}
                    onKeyDown={this.handleKeyDown}
                    innerRef={(ref) => {
                      this.nextButton = ref;
                    }}
                  >
                    Next &gt;
                  </Button>
                </div>
              </div>
            </div>
            <div className={'col-12 col-sm-auto'}>
              {!submitted && (
                <AsyncButton
                  id={this.saveButtonId}
                  className="btn-outline"
                  loading={loading}
                  spinner={this.showSpinnerForElement(this.saveButtonId)}
                  onClick={this.handleSaveButtonClick}
                  onKeyDown={this.handleKeyDown}
                >
                  Save
                </AsyncButton>
              )}
            </div>
          </div>
        )}
        <ReactResizeDetector handleHeight onResize={this.onResize} />
      </div>
    );
  }
}

TripDelayStep.propTypes = {
  form: PropTypes.object,
  onFormDataChange: PropTypes.func,
  prev: PropTypes.func,
  next: PropTypes.func,
  onFormDataSave: PropTypes.func,
  loading: PropTypes.bool,
  isSummary: PropTypes.bool,
  submitted: PropTypes.bool,
  adjust: PropTypes.func,
  makeValid: PropTypes.func,
  makeError: PropTypes.func,
  onNext: PropTypes.func,
  step: PropTypes.number,
  currentStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isReadOnly: PropTypes.bool,
  errors: PropTypes.any,
  onResetFormTravelInterruption: PropTypes.func,
  onResetFormTravelDelay: PropTypes.func,
  sendPhysicianEmail: PropTypes.func,
  validateStep: PropTypes.string,
  stepName: PropTypes.string,
};

const mapStateToProps = createStructuredSelector({
  form: makeSelectTripDelayStep(),
  errors: makeSelectTripDelayStepErrors(),
  currentStep: makeSelectCurrentStep(),
  loading: makeSelectProgressBarStatus(),
});

const mapDispatchToProps = (dispatch) => ({
  onFormDataChange: (propertyName, value) => dispatch(handleFormDataChange(propertyName, value)),
  onFormDataSave: () => dispatch(saveFormData()),
  onNext: (errors) => dispatch(nextSlide(errors)),
  onResetFormTravelInterruption: () => dispatch(resetFormTravelInterruption()),
  onResetFormTravelDelay: () => dispatch(resetFormTravelDelay()),
  onResetFormData: () => dispatch(resetFormData()),
  sendPhysicianEmail: () => dispatch(emailMedicalTravelDocument()),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
const withReducer = injectReducer({ key: 'tripDelayStep', reducer });

export default compose(
  withReducer,
  withConnect
)(TripDelayStep);



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.TripDelayStep/index.js